/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Operacje na czasie i dacie
 *
 * @export
 * @class DateTools
 * @extends {ObjectTools}
 */
import { ObjectTools } from "./ObjectTools.class";

export class DateTools extends ObjectTools {
	constructor() {
		super();
	}
	// ****************************************************************************************************
	// Funkcja odliczająca czas i wyświetlająca go w kontenerze  (po odliczeniu wywoluje funcEnd)
	// ****************************************************************************************************
	countDownTime(ts, target, funcEnd, display="std") {
		var that = this;
		if (ts > 0) {
			setTimeout(function () {
				ts--;
				if ( display == "tabs" )
					$(target).html(that.secondsToTimeFormatHMSTabs(ts));
				else {
					$(target).html(that.secondsToTimeFormatHMS(ts));
				}
				if (ts == 0) {
					funcEnd();
				} else {
					that.countDownTime(ts, target, funcEnd, display);
				}
			}, 1000);
		}
		return false;
	}
	// ****************************************************************************************************
	// Funkcja przeliczajaca sekundy na format: h:(0)m:(0)s
	// ****************************************************************************************************
	secondsToTimeFormatHMS(ts) {
		var s = ts % 60;
		var m = ((ts - s) / 60) % 60;
		var h = (((ts - s) / 60) - m) / 60;
		if (s < 10)
			s = '0' + s;
		if (m < 10)
			m = '0' + m;
		if (h < 10)
			h = '0' + h;
		return h + ':' + m + ':' + s;
	}
	secondsToTimeFormatHMSTabs(ts) {
		var s = ts % 60;
		var m = ((ts - s) / 60) % 60;
		var h = (((ts - s) / 60) - m) / 60;
		s = '<span>' + ( (s - s % 10) / 10 ) + '</span><span>' + ( s % 10 ) + '</span>';

		m = '<span>' + ( (m - m % 10) / 10 ) + '</span><span>' + ( m % 10 ) + '</span>';

		h = '<span>' + ( (h - h % 10) / 10 ) + '</span><span>' + ( h % 10 ) + '</span>';

		return h + '<strong>:</strong>' + m + '<strong>:</strong>' + s;
	}
	// ****************************************************************************************************
	// Odliczanie do konca "dzisiejszej" wysyłki
	// ****************************************************************************************************
	addShipmentCounter(countDownShipmentContID, shipmentTimerID) {
		let that = this;
		var countDownShipmentCont = $(countDownShipmentContID);

		if (countDownShipmentCont.length > 0) {
			var h = Number(countDownShipmentCont.data('limit')) - Number(countDownShipmentCont.data('h'));
			var m = Number(countDownShipmentCont.data('m'));
			var s = Number(countDownShipmentCont.data('s'));
			if (m != 0)
				h--;
			m = 60 - m;
			if (s != 0)
				m--;
			s = 60 - s;
			var totalS = (h * 60 * 60) + (m * 60) + s;
			that.countDownTime(totalS, shipmentTimerID, function () {
				$('.productShipmentToday').each(function (i, e) {
					$(e).html('<strong>' + $(e).data('shipment-regular') + '</strong>');
				});
				countDownShipmentCont.remove();
			});
		}
	}

	// ****************************************************************************************************
	// Odliczanie do konca promocji
	// ****************************************************************************************************
	addPromoCounter() {
		let that = this;
		var promoTimer = $(".promoTimer");

		if ( promoTimer.length > 0 ) {
			promoTimer.each(function(i,e){
				var timeLeft = Number($(e).data("time-left")); // musi być w sekundach
				var countLast24h = $(e).data("timer-mode");
				var display = $(e).data("display-mode");
				display = ( display ) ? display : "std";

				var off = false;

				if ( countLast24h == "last24h" ) {
					if ( timeLeft >= 86400 ) {
						$(".promoTimerLabel").remove();
						$(e).remove();
						off = true;
						// timeLeft = timeLeft % 86400;
					} else {
						timeLeft = timeLeft % 86400;
					}
				} else if ( countLast24h == "fullCounter" ) { // 99:59:59 s: 356400
					if ( timeLeft >= 356400 ) {
						$(".promoTimerLabel").remove();
						$(e).remove();
						off = true;
						// timeLeft = timeLeft % 356400;
					} else {
						timeLeft = timeLeft % 356400;
					}
				}

				if ( !off ) {
					if ( display == "tabs" ) {
						$(e).html(that.secondsToTimeFormatHMSTabs(timeLeft));
					} else {
						$(e).html(that.secondsToTimeFormatHMS(timeLeft));
					}

					that.countDownTime(timeLeft, this, function(){
						//$(e).remove();
						location.reload();
					}, display );
				}
			});
		}
	}
}